import { forwardRef } from "react";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { Form } from "@shared/components/Form";
import { getProductsService } from "@modules/defaultProducts/services/realService";

export const ProductsAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={getProductsService} />
  );
});

ProductsAutocomplete.displayName = "ProductsAutocomplete";
